<div
  class="terminal"
  [class.no-radius]="!rounded"
>

  <!-- 🔥 HEADER TOGGLE -->
  <div *ngIf="showHeader" class="terminal-header">
    <span class="dot red"></span>
    <span class="dot yellow"></span>
    <span class="dot green"></span>
    <span class="title">Logs</span>
  </div>

  <div class="terminal-body" #terminalBody>

    <div
      *ngFor="let log of logs; trackBy: trackByIndex"
      class="terminal-line"
      [ngClass]="getThemeClass(log.theme)"
    >
      <span class="terminal-prefix">></span>

      <kbd class="terminal-heading">
        {{ log.heading }}:
      </kbd>

      <span class="terminal-message">
        {{ log.message }}
      </span>
    </div>

  </div>
</div>